import React, { useState } from "react";
import TeamRanking from "./TeamRanking";
import RankingIcon from "../../Images/Cricket-Pages/Heading Icons/points-table.webp";

const TeamsComponent = () => {
  const [formatTypeValue, setFormatTypeValue] = useState("ODI");

  const formatTypes = [
    { typename: "ODI" },
    { typename: "Test" },
    { typename: "T20" },
  ];

  return (
    <div className="mb-10 pt-4 pb-1 mx-xl-0 mx-4 lg:px-20">
      {/* Format Type & Table */}
      <div className="my-4">
        {/* Format Type */}
        <div className="">
          <div className="bg-[linear-gradient(90.3deg,#AF6B16_0.16%,#F8DF65_50.89%,#DC9A2B_101.62%)] rounded-lg py-3 md:mb-[50px] mb-[10px] md:w-[90%] w-[100%] mx-auto">
            <p className="text-white md:text-[30px] text-[24px] font-semibold px-4 flex items-center justify-center gap-x-4 mb-0">
              <img
                src={RankingIcon}
                alt="squads"
                className="w-[60px] border-2 rounded-full border-[#fff] p-2 bg-[#000]"
              />
              Teams
            </p>
          </div>
          <div className="pb-4 border-b-2 border-[#dc9a2b12] lg:space-x-4 space-x-2 pt-4">
            {formatTypes.map((format, ind) => (
              <span
                style={{
                  backgroundColor:
                    format.typename === formatTypeValue ? "#DC9A2B" : "white",
                  color:
                    format.typename === formatTypeValue ? "white" : "black",
                }}
                onClick={() => setFormatTypeValue(format.typename)}
                key={ind}
                className={`info-hover bg-[#ffffff]  px-6 py-2 rounded-[32px] font-[600] cursor-pointer`}
              >
                {format.typename}
              </span>
            ))}
          </div>

          <TeamRanking formatTypes={formatTypeValue} />
        </div>
      </div>
    </div>
  );
};

export default TeamsComponent;
